(() => {
  const triggerSelector = '[data-wemond-experience-launch], product-card[data-wemond-experience-card="true"] a';
  let assetsPromise = null;

  const launcher = () => document.querySelector('wemond-experience-launcher#wemond-experience-launcher');

  const loadStyle = (url) => new Promise((resolve, reject) => {
    if (!url || [...document.styleSheets].some((sheet) => sheet.href === url)) return resolve();
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.addEventListener('load', resolve, { once: true });
    link.addEventListener('error', reject, { once: true });
    document.head.append(link);
  });

  const loadScript = (url) => new Promise((resolve, reject) => {
    if (customElements.get('wemond-experience-launcher')) return resolve();
    const existing = [...document.scripts].find((script) => script.src === url);
    if (existing) {
      existing.addEventListener('load', resolve, { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = url;
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.append(script);
  });

  const ensureAssets = () => {
    if (assetsPromise) return assetsPromise;
    const root = launcher();
    if (!root) return Promise.reject(new Error('Deneyim oluşturucu bulunamadı.'));
    assetsPromise = Promise.all([
      loadStyle(root.dataset.launcherStyle),
      loadScript(root.dataset.launcherScript)
    ]).catch((error) => {
      assetsPromise = null;
      throw error;
    });
    return assetsPromise;
  };

  document.addEventListener('pointerover', (event) => {
    if (event.target.closest?.(triggerSelector)) ensureAssets().catch(() => {});
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    if (event.target.closest?.(triggerSelector)) ensureAssets().catch(() => {});
  });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest?.(triggerSelector);
    if (!trigger || customElements.get('wemond-experience-launcher')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    try {
      await ensureAssets();
      launcher()?.open?.();
    } catch (error) {
      console.warn('[wemond] Deneyim oluşturucu yüklenemedi', error);
    }
  }, true);
})();
